import { useContext } from "react";
import { AuthContext, AuthContextType } from "../contexts/auth.context";

export const useAuth = () => {
    return useContext(AuthContext) as AuthContextType;
};
